module.exports = __webpack_public_path__ + "img/img3.81dc6110.png";